import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface GlassCardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function GlassCard({
  children,
  className = '',
  hoverEffect = false,
  ...props
}: GlassCardProps) {
  return <motion.div className={`glass-panel rounded-2xl p-6 relative overflow-hidden ${className}`} whileHover={hoverEffect ? {
    y: -4,
    transition: {
      duration: 0.2
    }
  } : undefined} {...props} data-id="element-594">
      {/* Subtle inner top highlight */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-black/[0.06] to-transparent" data-id="element-595" />

      <div className="relative z-10" data-id="element-596">{children}</div>
    </motion.div>;
}